import React from "react";
import { FormProvider } from "react-hook-form";
import { Box, Stack } from "@mui/material";
import { RFHTextField, RHFSelect } from "../../../components/RFH";

import Loader from "../../../components/Loader";
import CustomMenuItem from "../../../components/Menu/CustomMenuItem";
import { CustomButton } from "../../../components/Button/Button";
import { useCreateBoardForm } from "../hooks/useCreateBoardForm";

function Form({ onClose }) {
  const {
    methods,
    loading,
    isUserLoading,
    workflowOptions,
    userOptions,
    accessOptions,
    submit,
  } = useCreateBoardForm({ onClose });
  const { handleSubmit } = methods;

  return (
    <>
      <FormProvider {...methods}>
        <Box
          component="form"
          onSubmit={handleSubmit(submit)}
          noValidate
          className="form-container"
        >
          <Stack spacing={3}>
       
            <RFHTextField
              name="board_name"
              label={"Board Name"}
              className="board-name-field"
              required
            />

            <RHFSelect
              name="workflow_id"
              label={"Board Workflow"}
              className="board-name-field"
              required
            >
              {workflowOptions.map((option) => (
                <CustomMenuItem
                  key={`workflow-option-${option.value}`}
                  id={`workflow-option-id-${option.value}`}
                  value={option.value}
                >
                  {option.label}
                </CustomMenuItem>
              ))}
            </RHFSelect>

            <RHFSelect
              name="owner_user_id"
              label={"Board Owner"}
              className="board-name-field"
              required
            >
              {userOptions.length ? (
                userOptions.map((option) => (
                  <CustomMenuItem
                    key={`user-option-${option.value}`}
                    id={`user-option-id-${option.value}`}
                    value={option.value}
                  >
                    {option.label}
                  </CustomMenuItem>
                ))
              ) : isUserLoading ? (
                <div className="loader-center">
                  <Loader color={"black"} />
                </div>
              ) : null
              }
            </RHFSelect>

            <RHFSelect
              name="is_private"
              label={"Access"}
              className="board-name-field"
              required
            >
              {accessOptions.map((option) => (
                <CustomMenuItem
                  key={`access-option-${option.value}`}
                  value={option.value}
                >
                  {option.label}
                </CustomMenuItem>
              ))}
            </RHFSelect>

            <Box className="button-container d-flex">
              <CustomButton
                type="submit"
                variant="contained"
                className="create-button"
                disabled={loading}>
                Create
              </CustomButton>
              <CustomButton
                variant="outlined"
                className="cancel-button"
                onClick={onClose}
                disabled={loading}>
                Cancel
              </CustomButton>
            </Box>
          </Stack>
        </Box>
      </FormProvider>
    </>
  );
}

export default Form;
